import {z as zod} from "zod";

export type AssetsWorkspaceCapabilityConfiguration = Record<string, never>;

export const assetsWorkspaceCapabilityConfigurationValidator: zod.ZodType<AssetsWorkspaceCapabilityConfiguration> = zod.strictObject({});
